import { reduxKey } from './constants';

export interface PopoverOptions {
  params?: any;
}

export interface PopoverArrayItem {
  id: string;
  options: PopoverOptions;
}

export interface PopoverArrayState {
  [reduxKey]: PopoverArrayItem[];
}

// PopoverTypes shared between projects
export enum PopoverType {
  ADD_TO_COLLECTION_PRIMARY = 'ADD_TO_COLLECTION_PRIMARY',
  ADD_TO_COLLECTION_SECONDARY = 'ADD_TO_COLLECTION_SECONDARY',
  ADD_TO_PRIVATE_COLLECTION_PRIMARY = 'ADD_TO_PRIVATE_COLLECTION_PRIMARY',
  ADD_TO_PRIVATE_COLLECTION_SECONDARY = 'ADD_TO_PRIVATE_COLLECTION_SECONDARY',
  ADD_TO_GROUP_PRIMARY = 'ADD_TO_GROUP_PRIMARY',
  ADD_TO_GROUP_SECONDARY = 'ADD_TO_GROUP_SECONDARY',
  GALLECTION_FOLDER = 'GALLECTION_FOLDER',
}
